import axios from 'axios';
import API_ROUTES from '../../routes/ApiRoutes.js';

// Extraer la llamada al backend (service)
export const getSystemInfo = async () => {
    const { data } = await axios.get(API_ROUTES.SYSTEMINFO);
    return data;
};